import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

export const usePersistentTab = (defaultTab, paramName = 'tab') => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get(paramName) || defaultTab;

  const setActiveTab = useCallback((tab) => {
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      if (!tab || tab === defaultTab) {
        next.delete(paramName);
      } else {
        next.set(paramName, tab);
      }
      return next;
    }, { replace: true });
  }, [setSearchParams, defaultTab, paramName]);

  return [activeTab, setActiveTab];
};
